<template>
    <span v-if="count > 0" class="chat-unread-badge" :class="sizeClass">
        {{ displayCount }}
    </span>
</template>

<script>
export default {
    name: 'ChatUnreadBadge',
    props: {
        count: {
            type: Number,
            default: 0
        },
        size: {
            type: String,
            default: 'md', // sm, md, lg
            validator: (val) => ['sm', 'md', 'lg'].includes(val)
        },
        maxDisplay: {
            type: Number,
            default: 99
        }
    },
    computed: {
        displayCount() {
            if (this.count > this.maxDisplay) {
                return `${this.maxDisplay}+`;
            }
            return this.count;
        },
        sizeClass() {
            return `badge-${this.size}`;
        }
    }
};
</script>

<style scoped>
.chat-unread-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: white;
    background-color: #ef4444;
    border-radius: 9999px;
    min-width: 18px;
    text-align: center;
}

.badge-sm {
    font-size: 10px;
    padding: 1px 4px;
    min-width: 14px;
    height: 14px;
}

.badge-md {
    font-size: 11px;
    padding: 2px 6px;
    min-width: 18px;
    height: 18px;
}

.badge-lg {
    font-size: 12px;
    padding: 3px 8px;
    min-width: 22px;
    height: 22px;
}
</style>
